<div class="search-advanced-items">

  <div class="cosmetics-info-container">
    <div class="row info info-text reset-font">
      These settings have no impact on which items are shown or hidden, but change how items are displayed.
    </div>
    <button type="button" class="btn open-presets" (click)="openCosmeticPresetsDialog()">Cosmetic Presets</button>
  </div>

  <div class="search-advanced-pane full-width">
    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="filter-body">
            <span class="no-border" filter-title text="Drop Tier Styles">
              <app-content cid="drop-tier-styles" contentType="tip"></app-content>
            </span>
          </span>
        </div>
      </div>
      <div class="filter-group-body">

        <div class="navigation">
          <ul role="tablist" class="nav nav-tabs main full-width" style="font-size: 1em; margin-bottom: 3px;">
            <li role="presentation" class="menu-tab" [class.active]="dropTierTab === 'currency'">
              <a (click)="selectTab('currency')">
                <span>Currency</span>
              </a>
            </li>
            @if (poe1) {
              <li role="presentation" class="menu-tab" [class.active]="dropTierTab === 'divination-cards'">
                <a (click)="selectTab('divination-cards')">
                  <span>Divination Cards</span>
                </a>
              </li>
            }
            <li role="presentation" class="menu-tab" [class.active]="dropTierTab === 'items'">
              <a (click)="selectTab('items')">
                <span>Items</span>
              </a>
            </li>
            <li role="presentation" class="menu-tab" [class.active]="dropTierTab === 'uniques'">
              <a (click)="selectTab('uniques')">
                <span>Uniques</span>
              </a>
            </li>
            <li role="presentation" class="menu-tab" [class.active]="dropTierTab === 'chance-bases'">
              <a (click)="selectTab('chance-bases')">
                <span>Chance Bases</span>
              </a>
            </li>
          </ul>
        </div>

        @if (dropTierTab === 'currency') {
          @for (tier of filter.tierCosmetics; track tier.order) {
            <app-tier-cosmetics
              [filter]="filter"
              [tier]="tier"
              [tierLevel]="tier.tier"
              [isFirst]="tier.order === 0"
              [isLast]="tier.order === filter.tierCosmetics.length - 1"
              (updateFilter)="updateFilter()"
            ></app-tier-cosmetics>
          }
        }

        @if (dropTierTab === 'divination-cards') {
          @for (tier of filter.divCardTierCosmetics; track tier.order; let i = $index; let last = $last) {
            <app-tier-cosmetics
              [filter]="filter"
              [disabled]="filter.divCardCosmeticsSameAsTierCosmetics"
              [tier]="filter.divCardCosmeticsSameAsTierCosmetics ? filter.tierCosmetics[i] : tier"
              [tierLevel]="tier.tier"
              [isFirst]="tier.order === 0"
              [isLast]="tier.order === filter.divCardTierCosmetics.length - 1"
              (updateFilter)="updateFilter()"
              [divCard]="true"
            ></app-tier-cosmetics>
          }

          <div class="separator"></div>

          <div class="filter filter-property full-span" [class.disabled]="!filter.divCardCosmeticsSameAsTierCosmetics">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.divCardCosmeticsSameAsTierCosmetics"
                (click)="filter.divCardCosmeticsSameAsTierCosmetics = !filter.divCardCosmeticsSameAsTierCosmetics; updateFilter();"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Use Currency Tier Cosmetics instead">
                If you don't want specific styles for Divination Cards, you can use the Currency Tier Cosmetics instead. You can still select a different Minimap Icon for Divination Cards, and override the label style.
              </span>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [disabled]="!filter.divCardCosmeticsSameAsTierCosmetics"
                    [class.off]="!filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions?.minimapIconShape"
                    (click)="toggleDivCardMinimapIconShape()"></button>
                </span>
                <span class="table-checkbox-label">Map Icon</span>
              </div>
              <span class="sep"></span>
              <app-select-minimap-icon
                [(ngModel)]="filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions!.minimapIconShape"
                (selectedValueChange)="updateFilter()"
                [disabled]="!filter.divCardCosmeticsSameAsTierCosmetics || !filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions?.minimapIconShape">
              </app-select-minimap-icon>
              <span class="sep"></span>
              <button class="btn toggle-button" style="padding: 0px !important;" [disabled]="!filter.divCardCosmeticsSameAsTierCosmetics"
                (click)="divinationCardCosmeticControls.labelOptionsOpen = !divinationCardCosmeticControls.labelOptionsOpen">
                <div app-label-viewer
                  [isDivinationCard]="true"
                  [displayOptions]="filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions"
                  [exampleName]="'Example Card'"
                  [clickable]="filter.divCardCosmeticsSameAsTierCosmetics"></div>
              </button>
            </span>
          </div>

          <app-cosmetic-settings style="display: table;"
            [cosmeticOptions]="filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions!"
            [cosmeticControls]="divinationCardCosmeticControls"
            [active]="filter.divCardCosmeticsSameAsTierCosmetics"
            filterClasses="filter-padded"
            (updateFilter)="updateFilter()"
          >
          </app-cosmetic-settings>
        }

        @if (dropTierTab === 'items') {
          @for (tier of filter.equipmentTierCosmetics; track tier.order; let i = $index; let last = $last) {
            <app-tier-cosmetics
              [filter]="filter"
              [class.separator]="last"
              [disabled]="filter.equipmentCosmeticsSameAsTierCosmetics"
              [tier]="filter.equipmentCosmeticsSameAsTierCosmetics ? filter.tierCosmetics[i] : tier"
              [tierLevel]="tier.tier"
              [isFirst]="tier.order === 0"
              [isLast]="tier.order === filter.equipmentTierCosmetics.length - 1"
              (updateFilter)="updateFilter()"
              [equipment]="true"
            ></app-tier-cosmetics>
          }

          <div class="filter filter-property full-span" [class.disabled]="!filter.equipmentCosmeticsSameAsTierCosmetics">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.equipmentCosmeticsSameAsTierCosmetics"
                (click)="filter.equipmentCosmeticsSameAsTierCosmetics = !filter.equipmentCosmeticsSameAsTierCosmetics; updateFilter();"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Use Currency Tier Cosmetics instead">
                If you don't want specific styles for Items, you can use the Currency Tier Cosmetics instead. You can still select a different Minimap Icon for Items, and override the label style.

                <br /><br />Below, you can further override the Minimap Icon and label styles of specific types of items.
              </span>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [disabled]="!filter.equipmentCosmeticsSameAsTierCosmetics"
                    [class.off]="!filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions?.minimapIconShape"
                    (click)="toggleEquipmentMinimapIconShape()"></button>
                </span>
                <span class="table-checkbox-label">Map Icon</span>
              </div>
              <span class="sep"></span>
              <app-select-minimap-icon
                [(ngModel)]="filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions!.minimapIconShape"
                (selectedValueChange)="updateFilter()"
                [disabled]="!filter.equipmentCosmeticsSameAsTierCosmetics || !filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions?.minimapIconShape">
              </app-select-minimap-icon>
              <span class="sep"></span>
              <button class="btn toggle-button" style="padding: 0px !important;" [disabled]="!filter.equipmentCosmeticsSameAsTierCosmetics"
                (click)="equipmentCosmeticControls.labelOptionsOpen = !equipmentCosmeticControls.labelOptionsOpen">
                <div app-label-viewer
                  [rarity]="Rarity.Rare"
                  [displayOptions]="filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions"
                  [exampleName]="'Example Item'"
                  [clickable]="filter.equipmentCosmeticsSameAsTierCosmetics"></div>
              </button>
            </span>
          </div>

          <app-cosmetic-settings style="display: table;"
            [cosmeticOptions]="filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions!"
            [cosmeticControls]="equipmentCosmeticControls"
            [active]="filter.equipmentCosmeticsSameAsTierCosmetics"
            filterClasses="filter-padded"
            (updateFilter)="updateFilter()"
          >
          </app-cosmetic-settings>
        }

        @if (dropTierTab === 'uniques') {
          @for (tier of filter.uniqueTierCosmetics; track tier.order) {
            <app-tier-cosmetics
              [filter]="filter"
              [tier]="tier"
              [tierLevel]="tier.tier"
              [isFirst]="tier.order === 0"
              [isLast]="tier.order === filter.uniqueTierCosmetics.length - 1"
              (updateFilter)="updateFilter()"
            ></app-tier-cosmetics>
          }
        }

        @if (dropTierTab === 'chance-bases') {
          @for (tier of filter.chanceBaseTierCosmetics; track tier.order) {
            <app-tier-cosmetics
              [filter]="filter"
              [tier]="tier"
              [tierLevel]="tier.tier"
              [isFirst]="tier.order === 0"
              [isLast]="tier.order === filter.chanceBaseTierCosmetics.length - 1"
              (updateFilter)="updateFilter()"
            ></app-tier-cosmetics>
          }
        }
      </div>
    </div>
  </div>

  @if (dropTierTab === 'items') {
    <div class="search-advanced-pane full-width" style="padding-bottom: 0px;">
      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="filter-body">
              <span filter-title text="Item Type Overrides">
                Here you can specify if you want to override the default label style & Minimap Icon for specific types of items.
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="search-advanced-pane blue">
      <div class="filter-group">
        <div class="filter-group-body">
          <app-item-type-override-cosmetics
            [override]="filter.myItemsStyleOverride"
            [exampleName]="'Favourite Equipment'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          <app-item-type-override-cosmetics
            [override]="filter.levelingItemsStyleOverride"
            [exampleName]="'Leveling Gear'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          <app-item-type-override-cosmetics
            [override]="filter.salvagingItemsStyleOverride"
            [exampleName]="'Salvaging Gear'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          <app-item-type-override-cosmetics
            [override]="filter.craftingBasesStyleOverride"
            [exampleName]="'Crafting Base'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          <app-item-type-override-cosmetics
            [override]="filter.identifiedItemsStyleOverride"
            [rarity]="Rarity.Rare"
            [exampleName]="'Identified Item'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          @if (poe2) {
            <app-item-type-override-cosmetics
              [override]="filter.unidentifiedItemsStyleOverride"
              [rarity]="Rarity.Rare"
              [exampleName]="isMobile() ? 'Unidentified Item' : 'Tiered Unidentified Item'"
              (updateFilter)="updateFilter()"
            ></app-item-type-override-cosmetics>
          }
        </div>
      </div>
    </div>

    <div class="search-advanced-pane blue">
      <div class="filter-group">
        <div class="filter-group-body">
          <app-item-type-override-cosmetics
            [override]="filter.goldStyleOverride"
            [exampleName]="'Gold'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          @if (poe2) {
            <app-item-type-override-cosmetics
              [override]="filter.verisiumStyleOverride"
              [isCurrency]="true"
              [exampleName]="'Verisium'"
              (updateFilter)="updateFilter()"
            ></app-item-type-override-cosmetics>
          }

          <app-item-type-override-cosmetics
            [override]="filter.mapStyleOverride"
            [isWaystone]="true"
            [exampleName]="poe1 ? 'Map' : 'Waystone'"
            (updateFilter)="updateFilter()"
          ></app-item-type-override-cosmetics>

          @if (poe1) {
            <app-item-type-override-cosmetics
              [override]="filter.gemStyleOverride"
              [isPoe1Gem]="true"
              [exampleName]="'Gem'"
              (updateFilter)="updateFilter()"
            ></app-item-type-override-cosmetics>
          }
        </div>
      </div>
    </div>
  }

  <div class="search-advanced-pane full-width">
    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="filter-body">
            <span filter-title text="Hidden Items">
              Here you can specify if you want the label styles of hidden items to be smaller and transparent when you hold the <span class="key">Alt</span> key, so that more interesting items like currency are more visible by comparison.
            </span>
          </span>
        </div>
      </div>

      <div class="filter-group-body ">
        <div class="filter filter-property">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.cosmeticSettings.hiddenGearSmallAndTransparent"
              (click)="filter.cosmeticSettings.hiddenGearSmallAndTransparent = !filter.cosmeticSettings.hiddenGearSmallAndTransparent; updateFilter();"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Hidden Gear Transparent" style="width: 190px;"></span>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!filter.cosmeticSettings.hiddenFlaskSmallAndTransparent"
                  (click)="filter.cosmeticSettings.hiddenFlaskSmallAndTransparent = !filter.cosmeticSettings.hiddenFlaskSmallAndTransparent; updateFilter();"></button>
              </span>
              <span class="table-checkbox-label" style="width: 113px;">
                <span class="filter-title-text">Flasks</span>
              </span>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!filter.cosmeticSettings.hiddenJewellerySmallAndTransparent"
                  (click)="filter.cosmeticSettings.hiddenJewellerySmallAndTransparent = !filter.cosmeticSettings.hiddenJewellerySmallAndTransparent; updateFilter();"></button>
              </span>
              <span class="table-checkbox-label" style="width: 113px;">
                <span class="filter-title-text">Jewellery</span>
              </span>
            </div>
          </span>
        </div>
      </div>

    </div>
  </div>

  <div class="search-advanced-pane full-width">

    <app-custom-rule-groups-list
      [filter]="filter"
      [cosmetic]="true"
      [controller]="groupsCtrl"
      addGroupButtonLabel="Add new Custom Cosmetic Rule Group"
    >
      <ng-template #defaultGroupTopSlot>
        @if (settings.showContinueWarning()) {
          <div class="row row-total row-justify-content-left">
            <div class="info box reset-font">
              <div class="info-box-body">
                <h3 class="info-title">Explainer: <strong>Partial</strong></h3>
                <app-content cid="explainer-partial" contentType="tip"></app-content>
              </div>
              <span class="info-arrow info-arrow-down icon-arrow-down" style="right: 80px; bottom: 0;"></span>
              <a class="remove-warning-link" (click)="hideContinueWarning()">(I understand, dismiss)</a>
              <div class="close-info-btn" (click)="hideContinueWarning()">✕</div>
            </div>
          </div>
        }
      </ng-template>
    </app-custom-rule-groups-list>

  </div>
</div>

@if (showCosmeticPresetsDialog) {
  <div class="dialog-backdrop"></div>
  <app-cosmetic-presets [filter]="filter" (updateFilter)="updateFilter()" (close)="showCosmeticPresetsDialog = false" style="right: unset !important;"></app-cosmetic-presets>
}
